import InstallPromptLocation from '@alltrails/analytics/enums/InstallPromptLocation';
import InstallPromptSource from '@alltrails/analytics/enums/InstallPromptSource';
import InstallPromptType from '@alltrails/analytics/enums/InstallPromptType';
import logInstallPromptClicked from '@alltrails/analytics/events/logInstallPromptClicked';
import logInstallPromptDismissed from '@alltrails/analytics/events/logInstallPromptDismissed';
import logInstallPromptViewed from '@alltrails/analytics/events/logInstallPromptViewed';
import { JourneyEvent } from 'branch-sdk';
import useExperiment from 'hooks/useExperiment';
import { useEffect } from 'react';

// Adds amplitude tracking for branch events for the in-house-branch control variant
const useBranchAnalytics = (promptLocation: InstallPromptLocation) => {
  const branchExperiment = useExperiment('web-in-house-branch');
  const isControl = branchExperiment?.value === 'control';
  useEffect(() => {
    const handleBranchEvent = (event: JourneyEvent) => {
      // Unfortunately branch doesn't offer a way to differentiate between full-page interstitials & banners in the event listener.
      // They both use the id "branch-banner-iframe", so this checks the iframe height to differentiate between the two.
      // Branch banners have a fixed height of 76px.
      const isInterstitial = (document.querySelector('#branch-banner-iframe') as HTMLElement)?.offsetHeight > 200;

      if (event === 'didClickJourneyCTA') {
        logInstallPromptClicked({
          install_prompt_location: promptLocation,
          install_prompt_source: InstallPromptSource.Branch,
          install_prompt_type: isInterstitial ? InstallPromptType.Interstitial : InstallPromptType.Banner
        });
      }
      if (event === 'didClickJourneyClose') {
        logInstallPromptDismissed({
          install_prompt_location: promptLocation,
          install_prompt_source: InstallPromptSource.Branch,
          install_prompt_type: isInterstitial ? InstallPromptType.Interstitial : InstallPromptType.Banner
        });
      }
      if (event === 'didShowJourney') {
        logInstallPromptViewed({
          install_prompt_location: promptLocation,
          install_prompt_source: InstallPromptSource.Branch,
          install_prompt_type: isInterstitial ? InstallPromptType.Interstitial : InstallPromptType.Banner,
          signup_modal_trigger: null
        });
      }
    };

    if (isControl) {
      window.branch?.addListener(null, handleBranchEvent);
    }

    return () => {
      if (isControl) {
        window.branch?.removeListener(handleBranchEvent);
      }
    };
  }, [promptLocation, isControl]);
};

export default useBranchAnalytics;
